import React, {Component} from 'react'

import Field from '../../struct/Field'
import InputText from 'lib/struct/form/InputText'
import Hint from '../../struct/Hint'

import styles from './TokenTab.less'
import Checkbox from "lib/control/Checkbox"
import classNames from "classnames";
import {Link} from "../../../../libs/BSUI";

const {
    'hint': hintClass,
    'link': linkClass,
    'link-icon': linkIconClass,
} = styles


export default class TokenTab extends Component {
    constructor(props) {
        super()

        this.state = {
            debug: props.settings.debug,
            state_filter: props.settings.state_filter,
            date_filter: props.settings.date_filter,
            ya_id_in_orders: props.settings.ya_id_in_orders,
            dont_create_unpaid_orders: props.settings.dont_create_unpaid_orders
        }
    }

    handleChangeField = (name, checked) => {

        this.setState({
            [name]: checked
        })


        this.props.settings[name] = checked
    }

    render() {
        const {settings} = this.props
        return (
            <div>
                <div>

                    <Field label="Выводить номер заказа из Маркета в общем списке">
                        <Checkbox
                            checked={this.state.ya_id_in_orders}
                            onChange={e => this.handleChangeField('ya_id_in_orders', e.target.checked)}
                        />
                    </Field>
                    <Field label="Выводить фильтр заказов по статусам на вкладке Заказы">
                        <Checkbox
                            checked={this.state.state_filter}
                            onChange={e => this.handleChangeField('state_filter', e.target.checked)}
                        />
                    </Field>
                    <Field label="Выводить фильтр заказов по дате отгрузки на вкладке Заказы">
                        <Checkbox
                            checked={this.state.date_filter}
                            onChange={e => this.handleChangeField('date_filter', e.target.checked)}
                        />
                    </Field>
                    <Field label="Не создавать неоплаченные заказы">
                        <Checkbox
                            checked={this.state.dont_create_unpaid_orders}
                            onChange={e => this.handleChangeField('dont_create_unpaid_orders', e.target.checked)}
                        />
                    </Field>
                    <Field label="Дебаг-режим">
                        <Checkbox
                            checked={this.state.debug}
                            onChange={e => this.handleChangeField('debug', e.target.checked)}
                        />
                    </Field>
                    <div className={styles['instruction']}>
                        В случае возникновения проблем, пожалуйста, обратитесь к <a target="_blank" href="https://bodysite.ru/help/1975/diagnostika-raboty-plagina-integratsiya-s-yandeksmarket/">инструкции по диагностике</a>
                    </div>
                </div>
            </div>
        )
    }

}
